import Heading from '@eversports/klimt-primitives/legacy/Heading'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../../../../../localization/react'
import SearchUsers from '../SearchUsers'
import ShareYourProfile from '../ShareYourProfile'

import SuggestedFriends from './SuggestedFriends'
import SyncContacts from './SyncContacts'

interface Props {
  profileImage?: string
}

const FindFriends = ({ profileImage }: Props) => {
  return (
    <Stack gap={4} padding={{ xs: 4, md: 0 }}>
      <Stack>
        <Heading is="h3" sx={{ color: 'midnight' }}>
          <Localized id="find-friends-section-title" />
        </Heading>
        <Text variant="small" sx={{ color: 'carbon' }}>
          <Localized id="find-friends-section-sub-title" />
        </Text>
      </Stack>
      <SuggestedFriends />
      <SearchUsers />
      <ShareYourProfile profileImage={profileImage} />
      <SyncContacts />
    </Stack>
  )
}

export default FindFriends
